module.exports = __webpack_public_path__ + "img/shangpinzhuisu.4d2c82cf.png";